import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { t } from '@/i18n';

/**
 * Provenance hint for automation-made project assignments: a small "auto"
 * badge with a tooltip explaining where the assignment came from —
 * 'rule' (tag rule) or 'correction' (inherited from the corrected invoice).
 * Manual assignments render without it.
 */
export function AutoAssignedBadge({ variant = 'rule' }: { variant?: 'rule' | 'correction' }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="outline"
          className="border-sky-500/40 bg-sky-500/10 px-1.5 py-0 text-[10px] font-normal text-sky-700 dark:text-sky-400"
        >
          {t('projects.autoBadge')}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-64">
        {t(variant === 'correction' ? 'projects.correctionAutoTooltip' : 'projects.autoTooltip')}
      </TooltipContent>
    </Tooltip>
  );
}
